import { noop } from "lodash-es";
import type { KSStorage, RegionControl, AddLangListenerParam, DocParam } from "./ksStorage.types";

export type { RegionControl } from "./ksStorage.types";

const NOOP_KS_STORAGE: KSStorage = {
  getBaseInfo: noop,
  getLangType: () => "",
  addLangListener: noop,
  logoutDialog: noop,
  docInit: noop,
  docSet: noop,
  docClose: noop,
  dynamicsInit: noop,
  initRegion: () => ({ remove: () => {}, show: () => {}, hide: () => {}, setRegion: () => {} }),
  initZones: () => ({ remove: () => {} }),
  on: noop,
  getValue: noop,
};

export function getKsStorage() {
  try {
    return __ksStorage__;
  } catch (e) {
    if (__DEV__) {
      console.warn("no `__ksStorage__` is found");
    }
    return NOOP_KS_STORAGE;
  }
}

export function getKsBaseInfo(info: "userInfo", cb: (value: KSUserInfo) => void): void;
export function getKsBaseInfo(info: "configData", cb: (value: KSConfigData) => void): void;
export function getKsBaseInfo(info: string, cb: (data: any) => void) {
  getKsStorage().getBaseInfo(info as any, cb);
}

export function getKsLangType() {
  return getKsStorage().getLangType();
}

export function ksLogoutDialog() {
  return getKsStorage().logoutDialog();
}

export function registerKsLangListener(params: AddLangListenerParam) {
  getKsStorage().addLangListener(params);
}

export function registerKsDocHandler(initParams?: DocParam) {
  if (initParams) {
    getKsStorage().docInit(initParams);
  }

  // document.querySelector("[data-ks-doc-url]")?.addEventListener("");
  document.addEventListener("click", openKsDocFromDataset);
}

export function openKsDocFromDataset(e: MouseEvent) {
  const target = e.target as HTMLElement | null;
  if (!target) {
    return;
  }

  const el = target.closest("[data-ks-doc-url],[data-ks-doc-en-url]") as HTMLElement | null;
  if (el) {
    let docUrl = el.dataset.ksDocUrl ?? "";
    let enDocUrl = el.dataset.ksDocEnUrl ?? "";
    if (!/^(https?:)?\/\//.test(docUrl)) {
      docUrl = `//docs.ksyun.com/documents/${docUrl}`;
      enDocUrl = `//endocs.ksyun.com/documents/${enDocUrl}`;
    }

    const zindex = +(el.dataset.ksDocZIndex ?? 1000);
    openKsDoc({
      indexUrl: docUrl,
      indexEnUrl: enDocUrl,
      zIndex: isNaN(zindex) || !zindex ? 1000 : zindex,
    });
  }
}

export function openKsDoc(params: DocParam) {
  __DEV__ && console.debug("openKsDoc", params);
  getKsStorage().docSet(params);
}

export function closeKsDoc() {
  getKsStorage().docClose();
}

export function openHelpDoc(url: number, enUrl?: number, zIndex?: number) {
  if (!url) {
    return;
  }

  getKsStorage().docSet({
    indexUrl: "//docs.ksyun.com/documents/" + url,
    indexEnUrl: "//endocs.ksyun.com/documents/" + (enUrl ?? url),
    zIndex: zIndex ? zIndex : 1000,
  });
}
